import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { Link } from 'react-router-dom';

export const Nav = styled.nav`
  width: 100%;
  background: #ffffff;
  padding: 0.5rem 1.5rem 0.5rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  height: 56px;
`;

export const Logo = styled.img`
  height: 40px;
  margin-left: 1rem;
  margin-right: 1.5rem;
`;

export const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;

  @media (max-width: 1024px) {
    position: fixed;
    top: 56px;
    left: 0;
    width: 100%;
    height: calc(100vh - 56px);
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(10px);
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 2rem 1rem;
    gap: 1.5rem;
    transform: translateX(${props => props.open ? '0' : '100%'});
    transition: transform 0.3s ease-in-out;
    overflow-y: auto;
    z-index: 99;
  }

  > a {
    text-decoration: none;
    color: ${theme.colors.text};
    font-weight: 500;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    border-radius: 6px;
    transition: all 0.2s ease;
    position: relative;

    &:hover {
      background: #f5f5f5;
      color: ${theme.colors.primary};
    }

    /* 活跃状态样式 */
    &.active {
      background: ${theme.colors.primary};
      color: white;

      &:hover {
        background: ${theme.colors.primary};
        color: white;
      }
    }

    @media (max-width: 1024px) {
      width: 100%;
      max-width: 200px;
      text-align: center;
      padding: 1rem 1.5rem;
      font-size: 1.1rem;
      border: 1px solid rgba(238, 238, 238, 0.5);
      background: rgba(250, 250, 250, 0.9);

      &:hover {
        background: ${theme.colors.primary};
        color: white;
        border-color: ${theme.colors.primary};
      }

      /* 移动端活跃状态 */
      &.active {
        background: ${theme.colors.primary};
        color: white;
        border-color: ${theme.colors.primary};

        &:hover {
          background: ${theme.colors.primary};
          color: white;
        }
      }
    }
  }
`;

export const HamburgerIcon = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;
  padding: 0.5rem;
  margin-right: 1rem;

  @media (max-width: 1024px) {
    display: flex;
  }

  span {
    width: 25px;
    height: 3px;
    background: ${theme.colors.text};
    margin: 3px 0;
    transition: 0.3s;
    border-radius: 2px;

    &:nth-child(1) {
      transform: ${props => props.open ? 'rotate(-45deg) translate(-5px, 6px)' : 'rotate(0)'};
    }

    &:nth-child(2) {
      opacity: ${props => props.open ? '0' : '1'};
    }

    &:nth-child(3) {
      transform: ${props => props.open ? 'rotate(45deg) translate(-5px, -6px)' : 'rotate(0)'};
    }
  }
`;

export const Overlay = styled.div`
  display: none;
  
  @media (max-width: 1024px) {
    display: ${props => props.open ? 'block' : 'none'};
    position: fixed;
    top: 56px;
    left: 0;
    width: 100%;
    height: calc(100vh - 56px);
    background: rgba(0, 0, 0, 0.3);
    z-index: 98;
  }
`;

export const DesktopButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const MobileButtonGroup = styled.div`
  display: none;

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 200px;
    gap: 0;
    margin-top: 0.5rem;
  }
`;

export const AssessmentButton = styled(Link)`
  background: #3949ab;
  color: #fff !important;
  font-weight: 700;
  border-radius: 20px;
  padding: 0.5rem 1.3rem;
  margin-left: 1rem;
  font-size: 1rem;
  box-shadow: 0 2px 8px rgba(57,73,171,0.08);
  border: none;
  transition: background 0.2s, color 0.2s, transform 0.2s;
  display: inline-block;
  text-align: center;
  text-decoration: none;
  outline: none;

  &:hover, &:focus {
    background: #303f9f;
    color: #fff !important;
    transform: translateY(-2px) scale(1.04);
  }

  @media (max-width: 1024px) {
    width: 100%;
    margin: 0.5rem 0 0 0;
    font-size: 1.1rem;
    padding: 1rem 1.5rem;
    border-radius: 12px;
  }
`;

export const LoginButton = styled(Link)`
  background: ${theme.colors.primary};
  color: #fff !important;
  font-weight: 700;
  border-radius: 20px;
  padding: 0.5rem 1.3rem;
  margin-left: 0.5rem;
  font-size: 1rem;
  box-shadow: 0 2px 8px rgba(241, 175, 89, 0.15);
  border: none;
  transition: background 0.2s, color 0.2s, transform 0.2s;
  display: inline-block;
  text-align: center;
  text-decoration: none;
  outline: none;
  white-space: nowrap;

  &:hover, &:focus {
    background: #e09a3e;
    color: #fff !important;
    transform: translateY(-2px) scale(1.04);
  }

  @media (max-width: 1024px) {
    width: 100%;
    margin: 0.5rem 0 0 0;
    font-size: 1.1rem;
    padding: 1rem 1.5rem;
    border-radius: 12px;
  }
`;